import React from 'react';
import { Activities } from '../components/Activities';
import { EverythingElseMatters } from '../components/EverythingElseMatters';
import { FloatingMenu } from '../components/FloatingMenu';
import { Footer } from '../components/Footer';
import { Header } from '../components/Header';
import { ProjectGrid } from '../components/ProjectGrid';
export function Home() {
  return <div className="flex min-h-screen w-full flex-col" id="top" data-id="element-100" data-mp="1zhxkqdjnmqzd">
      <FloatingMenu data-id="element-101" data-mp="1zjs61syu8l3z" />
      <Header data-id="element-102" data-mp="1zkaa3brqs3mg" />
      <main className="w-full flex-grow bg-gradient-to-b from-[#01052a] to-[#a7c0d2] text-white" data-id="element-103" data-mp="24gsci4zlnpvm">
        <div className="container mx-auto px-4 py-14 md:py-20" data-id="element-104" data-mp="29gdbugiom08v">
          <section id="about" aria-labelledby="mission-title" className="mx-auto max-w-4xl scroll-mt-20" data-id="element-105" data-mp="29etvkpx0zp73">
            <h1 id="mission-title" className="mb-10 text-center text-3xl font-bold" data-id="element-106" data-mp="3kw1yt7vxqz9o">
              Our Mission
            </h1>
            <div className="space-y-5 text-lg leading-8" data-id="element-107" data-mp="30wrpihk53zg2">
              <p data-id="element-108" data-mp="30w9kavfi2aw0">
                As a nonprofit organization, our purpose is to inspire, promote,
                and support scientific, educational, arts, and cultural projects
                that advance our understanding of the human brain and accelerate
                its development.
              </p>
              <p data-id="element-109" data-mp="2mwqqz8rcl43r">
                We believe that meaningful progress comes from combining modern
                neuroscience with evolutionary, ethnocultural, and artistic
                perspectives. By bridging these disciplines, we aim to reveal
                insights from the past, make sense of the present, and open new
                pathways for exploring — and expanding — the potential of the
                human mind.
              </p>
              <p data-id="element-110" data-mp="1z7pcb3rx8wq1">
                Our work focuses particularly on projects that are often
                overlooked because of their interdisciplinary nature, uncertain
                timelines, or unconventional approaches. We support initiatives
                that push the boundaries of how we understand consciousness,
                perception, healing, and human potential.
              </p>
            </div>
          </section>

          <div className="mx-auto my-16 h-px max-w-4xl bg-white/25 md:my-20" data-id="element-111" data-mp="1aodv2m0n48lu" />

          <div className="mx-auto max-w-4xl" data-id="element-112" data-mp="1fmfej81za9xu">
            <Activities data-id="element-113" data-mp="23b8c18y90puk" />
          </div>

          <section id="projects" aria-labelledby="projects-title" className="mt-20 scroll-mt-20" data-id="element-114" data-mp="23c9qlneh3uh1">
            <h2 id="projects-title" className="mb-10 text-center text-3xl font-bold" data-id="element-115" data-mp="28c4gbnmiie0i">
              Our Projects
            </h2>
            <EverythingElseMatters data-id="element-116" data-mp="1yixeuduw7i5p" />

            <div className="mt-16" data-id="element-117" data-mp="2ma2ryl9g7wcb">
              <h3 className="mb-8 text-center text-2xl font-bold" data-id="element-118" data-mp="2m91gwgsfn9ul">
                Other Supported Projects
              </h3>
              <ProjectGrid data-id="element-119" data-mp="2r2dulvvkpw8k" />
            </div>
          </section>

          <section id="working-with-us" aria-labelledby="working-title" className="mx-auto mt-20 max-w-4xl scroll-mt-20 border-t border-white/30 pt-14" data-id="element-120" data-mp="fl0r7r2oeuue">
            <h2 id="working-title" className="mb-8 text-center text-2xl font-bold" data-id="element-121" data-mp="oedw7re0lmwu">
              Work With Us
            </h2>
            <div className="space-y-4 text-lg leading-8" data-id="element-122" data-mp="3ssc74pjdtyub">
              <p data-id="element-123" data-mp="3ssvq89krqt9x">
                Improbability Foundation is not currently actively seeking new
                projects to support.
              </p>
              <p data-id="element-124" data-mp="5o5u9cm1x2i8">
                However, we remain open to “improbable” ideas that align with our
                mission and can be developed in collaboration with people or
                organizations that already have some resources in place.
              </p>
              <p className="pt-4 text-base text-white/75" data-id="element-125" data-mp="1h4merkcgq9by">
                Improbability Foundation is a charitable foundation registered
                in April 2022 in the canton of Geneva under UID CHE-140.238.614
                and administered in cooperation with Reliance Trust Group.
              </p>
            </div>
          </section>
        </div>
      </main>
      <Footer data-id="element-126" data-mp="2hahrdebcgw3t" />
    </div>;
}